export function truncate(value: string, limit: number, strip_tags = false) {
  if (strip_tags) {
    value = value.replace(/<[^>]+>/g, "");
  }
  if (!value) {
    return "";
  }
  if (value.length > limit) {
    value = value.substring(0, limit).trim() + "...";
  }
  return value;
}
